
import Vue from 'vue';
import { getPortfolioPath } from '@/utils/routes';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import ArrowLeftIcon from '~/assets/svg/u_arrow-left.vue.svg';

export default Vue.extend({
  name: 'PublicPortfolioPreviewHeader',
  components: {
    BravadoButtonV3,
    ArrowLeftIcon,
  },
  computed: {
    salesPortfolioLink(): string {
      return getPortfolioPath(this.$route.params.slug);
    },
  },
});
